import type { VirtualKeyboardLayout } from 'mathlive';

import { MATH_SLOT_KEY_INSERT } from './answerSlotAuthoring';

// Ministry-of-Education required symbols (PBI #528633) that aren't on MathLive's stock keyboard.
// This is a SUPPLEMENTARY layer appended to the full `'default'` keyboard (see `applyKeyboardLayout`
// in MathLiveField), so AUTHORS always get every standard sign AND these. Students do NOT use the
// MathLive virtual keyboard — they get a separate custom on-screen keyboard (see
// `packages/core/.../components/MathKeyboard`). Add new required glyphs here (`\stackrel{?}{=}`
// stands in for ≟, which has no native LaTeX command).
//
// The Subscript key (PBI #530365) mirrors MathLive's stock superscript, inverted — for chemical
// formulas (CO₂, H₂O). `insert` uses MathLive's selection tokens: `#@` wraps the current selection
// as the base (selecting `O` then tapping it yields `O_{▢}`) and `#?` is the navigable subscript
// placeholder; with no selection it inserts `_{#?}`, binding to the preceding atom.
export const MATH_REQUIRED_SYMBOLS_LAYOUT: VirtualKeyboardLayout = {
  label: '∡°',
  tooltip: 'Math symbols',
  rows: [
    [
      { latex: '\\measuredangle' },
      { latex: '\\degree' },
      { latex: '\\stackrel{?}{=}' },
      { latex: '\\{' },
      { latex: '\\}' },
      { latex: '\\{#?\\}' },
      { latex: '\\square_{\\square}', insert: '#@_{#?}', tooltip: 'Subscript' }
    ]
  ]
};

// Answer-template editors only (PBI 538086): the student-slot key, with the structures a slot usually
// sits in and the digits, so a whole exercise can be written without switching layers. The slot key
// wraps the selection (`#@`) — select a value and press it, and that value becomes the slot's answer;
// press it in an empty hole and the hole becomes an empty slot. Its keycap is drawn like the slot
// itself (dashed), unlike mathlive's own solid template-hole squares.
const STUDENT_BOX_KEYCAP_LABEL =
  '<span style="display:inline-block;width:1.1em;height:1.1em;border:2px dashed currentColor;border-radius:3px"></span>';

export const MATH_ANSWER_SLOT_LAYOUT: VirtualKeyboardLayout = {
  label: '▢?',
  tooltip: 'Student answer slot',
  rows: [
    [
      { label: STUDENT_BOX_KEYCAP_LABEL, insert: MATH_SLOT_KEY_INSERT, tooltip: 'Student answer slot', width: 1.5 },
      '\\sqrt{#0}',
      '\\frac{#@}{#?}',
      '#@^{#?}',
      '(',
      ')',
      '[separator]',
      '7',
      '8',
      '9'
    ],
    ['<', '>', '=', '\\le', '\\ge', '\\ne', '[separator]', '4', '5', '6'],
    ['+', '-', '\\times', '\\div', '[left]', '[right]', '[separator]', '1', '2', '3'],
    ['[backspace]', '[separator]', '0', '.']
  ]
};
